import styled from "styled-components";
import { Type } from "discover.medical.react-component-library";

export const StyledEvidenceSynopsisType = styled(Type)`
  background-color: ${({ theme }) => theme.colors.secondary.base};
  padding: ${({ theme }) => theme.space.sm} 0 ${({ theme }) => theme.space.sm}
    0.75rem;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: ${({ theme }) => theme.font.size.sm};
    margin-bottom: ${({ theme }) => theme.space.sm};
  }
`;

export const StyledEvidenceSynopsisDiv = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 0.75rem;
  margin: ${({ theme }) => theme.space.xl} 0 ${({ theme }) => theme.space.xl} -${({ theme }) => theme.space.md};
  border: 1px solid ${({ theme }) => theme.colors.gray400};
`;

export const StyledEvidenceSynopsisContent = styled.div`
  font-weight: ${({ theme }) => theme.font.weight.semibold};

  .evidence {
    font-weight: ${({ theme }) => theme.font.weight.normal};
    border-top: 1px solid ${({ theme }) => theme.colors.gray400};
    margin: 0.75rem 0 0;
    padding-left: 1.25rem;
  }
`;
